import { formatDate } from "@clipboard-health/date-time";
import { Input, Text, useModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useCallback } from "react";

import { DatePickerInputBottomSheet } from "../../../DateTime/DatePickerInputBottomSheet";

interface DateInputProps {
  label: string;
  value?: Date;
  onChange: (date: Date) => void;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
}

export function DateInput(props: DateInputProps) {
  const { label, value, onChange, disabled = false, error = false, required = false } = props;

  const modalState = useModalState();

  const handleDateSelect = useCallback(
    (selectedDate: Date) => {
      onChange(selectedDate);
      modalState.closeModal();
    },
    [onChange, modalState]
  );

  return (
    <>
      <Stack spacing={2}>
        <Text semibold variant="body1">
          {label}
          {required && " *"}
        </Text>
        <Input
          fullWidth
          readOnly
          placeholder="Select date"
          value={value ? formatDate(value, "MMM d, yyyy") : ""}
          error={error}
          disabled={disabled}
          iconType="calendar-navigation"
          sx={{
            "& .MuiInputBase-root": {
              cursor: disabled ? "default" : "pointer",
            },
            "& .MuiInputBase-input": {
              cursor: disabled ? "default" : "pointer",
            },
          }}
          onClick={() => {
            if (!disabled) {
              modalState.openModal();
            }
          }}
        />
      </Stack>

      <DatePickerInputBottomSheet
        modalState={modalState}
        initialDate={value}
        onConfirm={handleDateSelect}
      />
    </>
  );
}
